const ROUTES = {
  "/": {
    "name": "HomePage949c93158cd342b0B68094b42191d453",
    "type": "HTML",
    "key": "home-page"
  },
  "/about": {
    "name": "AboutUsPageEa95734a07e14ae28ba1B2c9dbb76297",
    "type": "HTML",
    "key": "about-us-page"
  },
  "/apply/*": {
    "name": "ApplicationPages23de6e93C07e4777Ab122512953bacdd",
    "type": "REFERENCE",
    "key": "application-pages"
  },
  "/events/public": {
    "name": "PublicEventsPage92bc8d59C39141b88e25Bd6248d67935",
    "type": "HTML",
    "key": "public-events-page"
  },
  "/join": {
    "name": "JoinUsPage1f9f946dE2d24173B3696de0262d4a56",
    "type": "REFERENCE",
    "key": "join-us-page"
  }
};

export default ROUTES;